export async function reconcileActiveQueries(queryClient, logger = console) {
    try {
        await queryClient.refetchQueries({ type: "active" });
        return true;
    } catch (error) {
        logger.warn("Native resume data reconciliation failed:", error);
        return false;
    }
}
